import Link from "next/link";
import { Col } from "react-bootstrap";
import { signIn } from "next-auth/react";
import styles from "@/styles/SocialSignInCard.module.css";
import Image from "next/image";

function SignUpCard(props) {
  const { pageStateHandler, userType } = props;
  let callbackUrl;
  if (userType == "customer") {
    callbackUrl = "/customer/profile";
  } else {
    callbackUrl = "/healer/my-account";
  }
  return (
    <Col sm={7} className="align-self-center">
      <div className={styles["login-customer-card"]}>
        <div className={styles["card-header"]}>
          <h4 className={styles["card-heading"]}>
            Register as {userType == "customer" ? "Customer" : "Healer"}
          </h4>
          <p>Register with your social accounts</p>
        </div>
        <div className={styles["login-body"]}>
          <ul>
            <li>
              <Link
                href={""}
                onClick={() => signIn("facebook", { callbackUrl })}
              >
                <Image
                  height={20}
                  width={20}
                  src="/images/facebook-icon.svg"
                  alt="Facebook Signup"
                />{" "}
                Sign-up With Facebook
              </Link>
            </li>
            <li>
              <Link href={""} onClick={() => signIn("google", { callbackUrl })}>
                <Image
                  height={20}
                  width={20}
                  src="/images/google-icon.svg"
                  alt="Google Signup"
                />{" "}
                Sign-up With Google
              </Link>
            </li>
          </ul>
          <p className={styles["heading-privacy"]}>
            By continuing, you agree to Zenkify LLC. &amp;s{" "}
            <Link href="/terms-and-conditions">Terms of Use</Link> and{" "}
            <Link href="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
        <div className={styles["card-footer"]}>
          <p>
            Already have an account?{" "}
            <Link
              href={`/auth/${userType}/signin`}
              shallow={true}
              onClick={() => pageStateHandler("credentialSignIn")}
            >
              Log In
            </Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default SignUpCard;
